import { useEffect, useRef, useState } from "react";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import {
  getEventDetails,
  getEventNewsList,
  getSingleEvent,
} from "../../services/about/about.service";
import styles from "./about.module.css";
import ReactBootstrapCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import NewsBar from "../../components/product/NewsBar";
import Title from "../../components/title";

let unlisten;
const EventDetails = ({ history, match }) => {
  const imgRef = useRef();
  const [loadingNews, setLoadingNews] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [events, setEvents] = useState(null);
  const [details, setDetails] = useState([]);
  const [news, setNews] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [activeTab, setActiveTab] = useState(0);

  const toggleModal = (item) => {
    setShowModal(true);

    let elSrc = null;

    if (item && item.server_relative_url) {
      elSrc = item.server_relative_url;
    }

    setTimeout(() => {
      document.getElementById("modal-about-source").src = elSrc;
    }, 10);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    getSingleEvent(match.params.id).then(({ data }) => {
      setEvents(data.data[0]);
      setBreadCrumbItems([
        { title: "خانه", url: "/" },
        { title: "رویدادها", url: "/events" },
        { title: data.data[0].title, url: "/events/" + data.data[0].id },
      ]);
    });
    getEventDetails(match.params.id).then(({ data }) => {
      setDetails((data && data.data) || []);
    });
    return () => {
      try {
        unlisten();
      } catch (e) {}
    };
  }, [match.params.id]);

  const changeBreadCrumbItems = (index) => {
    setActiveTab(0);
    setActiveIndex(index);
    const brItems = [...breadCrumbItems];
    setLoadingNews(true);
    getEventNewsList(details[index].guid).then(({ data }) => {
      setLoadingNews(false);
      setNews((data && data.data) || []);
    });
    if (brItems.length === 3) {
      brItems.push({
        title: details[index].title,
        url: "/events/" + match.params.id,
      });
      setBreadCrumbItems([...brItems]);
    } else {
      brItems[3] = {
        title: details[index].title,
        url: "/events/" + match.params.id,
      };
      setBreadCrumbItems([...brItems]);
    }
  };

  return (
    <>
      {events && <Title title={events.title} />}
      {showModal ? (
        <>
          <div id={styles.modalBackdrop} onClick={closeModal}></div>
          <div id={styles.modalWrapper}>
            <div className={styles.modalClose} onClick={closeModal}>
              &#x2715;
            </div>
            <img
              src={""}
              id={"modal-about-source"}
              ref={imgRef}
              alt={"modal"}
            />
          </div>
        </>
      ) : null}
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />

        <div className={"row"}>
          <div className={"col-xs-12 col-md-8"}>
            {events ? (
              <>
                {activeIndex !== -1 ? (
                  <>
                    <div
                      id={styles.contentEventTab}
                      onClick={() => setActiveTab(0)}
                      className={
                        activeTab === 0
                          ? `${styles.activeTab} pull-right`
                          : "pull-right"
                      }
                    >
                      محور های همایش
                    </div>
                    <div
                      id={styles.contentEventNewsTab}
                      onClick={() => setActiveTab(2)}
                      className={
                        activeTab === 2
                          ? `${styles.activeTab} pull-right`
                          : "pull-right"
                      }
                    >
                      اخبار
                    </div>
                    <div
                      id={styles.contentRelatedImagesTab}
                      onClick={() => {
                        setActiveTab(1);
                      }}
                      className={
                        activeTab === 1
                          ? `${styles.activeTab} pull-right`
                          : "pull-right"
                      }
                    >
                      تصاویر مرتبط
                    </div>
                  </>
                ) : null}
                <div className={"clearfix"}></div>
                {activeTab === 1 &&
                details &&
                details.length > 0 &&
                Array.isArray(details[activeIndex].attachment_files) &&
                details[activeIndex].attachment_files.length > 1 ? (
                  <div className={styles.aboutImageWrapper}>
                    <ReactBootstrapCarousel>
                      {details[activeIndex].attachment_files.map(
                        (item, index) => (
                          <div
                            key={item.file_name}
                            className={styles.elWrapper}
                            onClick={(e) => toggleModal(item)}
                          >
                            <SliderElem
                              item={item}
                              key={index + "-slider-main-elem"}
                              isActive={index === 0 ? true : false}
                            />
                          </div>
                        )
                      )}
                    </ReactBootstrapCarousel>
                  </div>
                ) : activeTab === 1 &&
                  details &&
                  details.length > 0 &&
                  Array.isArray(details[activeIndex].attachment_files) &&
                  details[activeIndex].attachment_files.length === 1 ? (
                  <img
                    src={
                      details[activeIndex].attachment_files[0]
                        .server_relative_url
                    }
                    alt={"event details"}
                  />
                ) : null}
                {activeTab === 0 ? (
                  <div
                    id={styles.tabContent}
                    dangerouslySetInnerHTML={{
                      __html:
                        activeIndex === -1
                          ? events.rich_description
                          : details[activeIndex].description,
                    }}
                  ></div>
                ) : null}
                {activeTab === 2 && !loadingNews ? (
                  news && news.length > 0 ? (
                    news.map((item, key) => {
                      return <NewsBar key={key + "-product-bar"} news={item} />;
                    })
                  ) : (
                    <div className={styles.loadingWrapper}>
                      {loadingNews ? (
                        <img
                          src={"../../../assets/image/loading.svg"}
                          alt={"در حال بار گذاری"}
                        />
                      ) : (
                        <div className={styles.loadingNoNews}>
                          اخباری موجود نیست
                        </div>
                      )}
                    </div>
                  )
                ) : null}
              </>
            ) : (
              <div className={styles.loadingWrapper}>
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <div className={"col-xs-12 col-md-4"}>
            <h2 className={styles.sidebarAboutTitle}>
              {events ? events.title : ""}
            </h2>
            {details && details.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {details.map((item, index) => (
                  <li
                    className={activeIndex === index ? styles.active : null}
                    onClick={() => changeBreadCrumbItems(index)}
                    key={index + "-key-tab-box"}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            ) : (
              <div className={styles.loadingWrapper}>
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
const SliderElem = ({ item, isActive }) => {
  return (
    <div
      className={
        isActive
          ? `${styles.item} ${styles.active} ${styles.aboutCarousel}`
          : `${styles.item} ${styles.aboutCarousel}`
      }
    >
      <img src={item.server_relative_url} alt={"slider elem"} />
    </div>
  );
};
export default EventDetails;
